// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__ljJNY","image":"BackButton_image__1W-Fw","tip":"BackButton_tip__2FK_-"};